/**
 * Scroll Animations Module
 * Handles staggered fade-in animations for feature cards using IntersectionObserver
 */

export function initScrollAnimations() {
  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // Show all elements immediately for reduced motion users
    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      el.classList.add('animate-on-scroll--visible');
    });
    return;
  }

  // Configuration
  const options = {
    root: null, // viewport
    rootMargin: '0px 0px -50px 0px', // trigger slightly before element enters viewport
    threshold: 0.1
  };

  // Create observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-on-scroll--visible');
        observer.unobserve(entry.target); // Only animate once
      }
    });
  }, options);

  // Observe all elements with animation class
  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });

  // Handle staggered animations for grids
  const staggeredContainers = document.querySelectorAll('[data-stagger-children]');

  staggeredContainers.forEach(container => {
    const staggerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const children = entry.target.querySelectorAll('.animate-on-scroll');
          children.forEach((child, index) => {
            // Add stagger delay as CSS variable
            child.style.setProperty('--stagger-delay', `${index * 100}ms`);
            // Small timeout to ensure CSS variable is applied
            setTimeout(() => {
              child.classList.add('animate-on-scroll--visible');
            }, 10);
          });
          staggerObserver.unobserve(entry.target);
        }
      });
    }, options);

    staggerObserver.observe(container);
  });
}
